import type { ListingResult } from "@kraahl/contract";
import type { SavedItemRowListing } from "@/lib/saved-item-row";

/**
 * Adapt a feed `ListingResult` to the `SavedItemRowListing` shape consumed by the
 * saved-item-row domain (`deriveSavedItemAction` / `effectiveSavedListingPrice` /
 * `savedActionLook`), so the DiscoveryRail's "Open to offers" rows show the real
 * derived action (Offer / Buy / Find similar) instead of a hardcoded "Listed".
 *
 * The only real shape gap is `price`: `ListingResult.price` is a string (PostgREST
 * numeric), `SavedItemRowListing.price` is a number — coerce here so a stray string
 * never leaks into `effectiveSavedListingPrice` or the OfferModal.
 */
export function feedListingToSavedListing(l: ListingResult): SavedItemRowListing {
  return {
    id: l.id,
    title: l.title,
    price: Number.parseFloat(l.price),
    currency: l.currency ?? null,
    image_urls: l.image_urls,
    condition: l.condition,
    grade: l.grade,
    quantity: l.quantity,
    listing_format: l.listing_format ?? null,
    type: l.type ?? null,
    scheduled_publish_at: l.scheduled_publish_at ?? null,
    auction_start_price: l.auction_start_price ?? null,
    auction_highest_bid: l.auction_highest_bid ?? null,
    auction_status: l.auction_status ?? null,
  };
}
